import React from "react";
import "./PageStyles.css";

function Contact() {
  return (
    <div className="page-container">
      <h1>Contact Alpha APK Store™</h1>

      <p>
        We are always open to feedback, support requests, copyright concerns,
        app removal requests, business inquiries, bug reports, feature
        suggestions, and partnership opportunities.
      </p>

      <h2>Support & General Questions</h2>

      <p>
        If you have any questions about APK downloads, Android compatibility,
        Google login issues, website access, broken pages, or feature requests,
        contact us anytime.
      </p>

      <p>
        📧 Email: <strong>alphaapkstore@gmail.com</strong>
      </p>

      <p>
        Response Time: Usually within 24–48 hours
      </p>

      <h2>Copyright / DMCA Requests</h2>

      <p>
        If you are a copyright owner and believe content should be reviewed or
        removed, please contact us with full details.
      </p>

      <h2>Technical Support</h2>

      <p>
        We can help with:
      </p>

      <ul>
        <li>APK page issues</li>
        <li>Android compatibility questions</li>
        <li>Google login problems</li>
        <li>Website loading issues</li>
        <li>Broken links</li>
        <li>Device compatibility checker issues</li>
      </ul>

      <h2>Website Ownership</h2>

      <p>
        <strong>Owner: KARANDEEP SINGH SANDHU</strong>
      </p>

      <p>
        Alpha APK Store is independently owned and continuously developed to
        provide a unique Android APK browsing experience.
      </p>

      <h2>Thank You</h2>

      <p>
        Thank you for supporting Alpha APK Store and helping us improve the
        platform for Android users worldwide.
      </p>
    </div>
  );
}

export default Contact;